import { render, staticRenderFns } from "./AppLayoutDefault.vue?vue&type=template&id=0a058ab7&"
import script from "./AppLayoutDefault.vue?vue&type=script&lang=js&"
export * from "./AppLayoutDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports